import { doc, getDoc } from 'firebase/firestore';
import { LEAD_TYPE_OPTIONS } from './leadFormHelpers';

export const LEAD_DISTRIBUTION_SETTINGS_DOC = 'leadAutoDistribution';

export function getLeadTypeOptions() {
  return LEAD_TYPE_OPTIONS;
}

export async function fetchLeadDistributionRules(db) {
  const snap = await getDoc(doc(db, 'settings', LEAD_DISTRIBUTION_SETTINGS_DOC));
  if (!snap.exists()) return {};
  return snap.data().rules || {};
}

/**
 * Atribui corretor ao lead com base nas regras, apenas se ainda não houver corretor.
 */
export function applyLeadDistributionToData(leadData, rules) {
  if (!rules || typeof rules !== 'object') return leadData;
  if (leadData.corretorAtendendo) return leadData;

  const type = leadData.type || 'help';
  const rule = rules[type];
  if (!rule?.brokerName) return leadData;

  return {
    ...leadData,
    corretorAtendendo: rule.brokerName
  };
}

export async function enrichLeadWithAutoDistribution(db, leadData) {
  if (leadData.corretorAtendendo) return leadData;
  try {
    const rules = await fetchLeadDistributionRules(db);
    return applyLeadDistributionToData(leadData, rules);
  } catch (error) {
    console.error('Erro ao aplicar distribuição automática de leads:', error);
    return leadData;
  }
}
